// Máscara de telefone BR, ao vivo. Aceita fixo (10 dígitos) e celular (11 dígitos):
//   (11) 3000-0000   /   (11) 99999-9999
// É campo de telefone: formata só os dígitos e ignora o excedente acima de 11 (não preserva
// sufixo livre). Ramal/observação vão no campo "Observações" do beneficiário, que é texto livre
// — não neste campo. O backend não valida o formato (aceita o que vier), mas a UI formata.
export const maskPhone = (raw: string): string => {
    const digits = (raw || '').replace(/\D/g, '').slice(0, 11);
    if (digits.length === 0) return '';
    if (digits.length <= 2) return `(${digits}`;
    const ddd = digits.slice(0, 2);
    const rest = digits.slice(2);
    // Fixo (8 dígitos após o DDD): 4+4. Celular (9): 5+4.
    if (rest.length <= 4) return `(${ddd}) ${rest}`;
    if (rest.length <= 8) return `(${ddd}) ${rest.slice(0, 4)}-${rest.slice(4)}`;
    return `(${ddd}) ${rest.slice(0, 5)}-${rest.slice(5)}`;
};
